import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const MinusIcon = ({ color = 'currentColor', width = 24, height = 24, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="3" y="13" width="2.5" height="18" rx="1.25" transform="rotate(-90 3 13)" fill={color} />
        </svg>
    );
};
